<template>
  <div>
    <a-row>
      <a-col :span="24" style="text-align: left;">
        <h3>
          <a-icon type="smile-o" style="margin-right: 10px;"/>欢迎加入，开启您的项目之旅吧！
        </h3>
        <h4>您可以...</h4>
      </a-col>
      <a-col :span="24">
        <CreateProjectModal>
          <a-button type="dashed" block>发起项目，吸引合作方</a-button>
        </CreateProjectModal>
      </a-col>
      <a-col :span="24">
        <a-button type="dashed" block @click="toDemand">去需求库探索待解决的需求</a-button>
      </a-col>
      <a-col :span="24">
        <a-button type="dashed" block @click="toCommunity">去项目社区发现感兴趣的项目</a-button>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { CreateProjectModal } from '@/components/Modal'

export default {
  name: 'NoDataGuide',
  components: {
    CreateProjectModal
  },
  data () {
    return {}
  },
  methods: {
    toDemand () {
      this.$router.push('/library/demands')
    },
    toCommunity () {
      this.$router.push('/community/public-sea')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
